// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface CursorArrowSmallIconSignature {
  Element: SVGSVGElement;
}

export const CursorArrowSmallIcon: TOC<CursorArrowSmallIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.414 13L19.707 18.293L18.293 19.707L13 14.415L9.707 17.707C9.518 17.896 9.262 18 9 18C8.924 18 8.847 17.992 8.77 17.974C8.434 17.894 8.161 17.645 8.051 17.317L4.051 5.317C3.932 4.957 4.025 4.561 4.293 4.293C4.561 4.025 4.957 3.933 5.317 4.052L17.317 8.052C17.645 8.162 17.894 8.434 17.973 8.771C18.053 9.108 17.952 9.462 17.707 9.707L14.414 13ZM6.581 6.582L9.438 15.149L15.148 9.437L6.581 6.582Z"/>
</svg>
</template>;